import React, { useState, useEffect } from "react";
import ImageViewer from "../../screens/ImageViewerV2.js";
import {
  getAllPublicDataV2,
  getScenesInPrototypeForPublic,
} from "../../api/configuratorApiV2.js";
import styles from "./ConfiguratorViewer.module.scss";
import { useParams } from "react-router-dom";
// import { history } from "../../history";
import { AnimatedLoader } from "../Loader/AnimatedLoader.js";
// import Loader from "../../common/Loader.js";
import { modelDataMap } from "../../helpers/configData.js";

let isMounted = false;

const ConfiguratorViewer = () => {
  const { uuid } = useParams();
  const [loader, setLoader] = useState(false);
  const [allStoreList, setAllStoreList] = useState([]);
  const [currentSelectedStore, setCurrentSelectedStore] = useState({});
  const [token, setToken] = useState(null);
  const [isRender, setIsRender] = useState(false);
  const [localConfiguratorData, setLocalConfiguratorData] = useState();
  const [localLayoutData, setLocalLayoutData] = useState();
  const [localProfileData, setLocalProfileData] = useState();
  const [localSceneData, setLocalSceneData] = useState();
  const [localImageData, setLocalImageData] = useState();
  const [allScenes, setAllScenes] = useState([]);
  const [measureToolImages, setMeasureToolImages] = useState([]);
  const [showArButton, setShowArButton] = useState(false);
  const [showMeasureTool, setShowMeasureTool] = useState(false);

  useEffect(() => {
    isMounted = true;
  }, []);

  useEffect(() => {
    if (localConfiguratorData?.tokenUrl) {
      setIsRender(checkIfShowRenderData());
      getAllDataFromModelId(checkIfShowRenderData());
      setShowArButton(localConfiguratorData?.arViewer || false);
      setShowMeasureTool(localConfiguratorData?.measureTool || false);
    }
  }, [localConfiguratorData]);

  useEffect(() => {
    if (uuid) {
      updateDataForModelIdLocal(uuid);
    }
  }, [uuid]);

  useEffect(() => {
    showMeasureTool && getDataFromJSON()
  }, [showMeasureTool])

  const getDataFromJSON = async (obj) => {
    // console.log("getDataFromJSON", obj);
    await fetch('/measureToolImages.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // console.log(data,"data");
        const allImages = data.allImages;
        if (allImages.length) {
          const id = parseInt(!isNaN(parseInt(uuid)) ? parseInt(uuid): null);
          // let index = 0;
          // if (allImages?.[id-1]) {
          //   index = id - 1;
          // }
          // let currentConfImages = allImages?.[index]?.imagesList;
          let currentConfImages = allImages?.find((item) => item.id === id)?.imagesList || [];
          // console.log(allImages,currentConfImages, "currentConfImages");
          if (currentConfImages?.length) {
            if (obj?.showSize) {
              currentConfImages = currentConfImages.filter((data) => data?.size === obj?.selectSize);
            }
            setMeasureToolImages(currentConfImages);
          }
        }
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
    }

  const updateDataForModelIdLocal = (uuid) => {

    const dataToShow = modelDataMap[uuid] || modelDataMap["13"];

    setLocalConfiguratorData(dataToShow?.configurator);
    setLocalLayoutData(dataToShow?.layout);
    setLocalProfileData(dataToShow?.profile);
    setLocalSceneData(dataToShow?.scene);

  };

  const checkIfShowRenderData = () => {
    return true;
  };

  const getAllDataFromModelId = async (isRender) => {
    try {
      setLoader(true);
      const promise = getAllPublicDataV2({
        newModelIds: localConfiguratorData?.tokenUrl,
        isRender,
        isOpenedFromAdminPanel: false,
      });
      const promise1 = getScenesInPrototypeForPublic({
        token: localConfiguratorData?.tokenUrl,
        is_render: isRender,
      });
      const promises = [promise, promise1];
      const data = await Promise.all(promises);
      const allData = data?.[0] || {};
      setAllScenes(data[1]);
      const rawData = JSON.parse(JSON.stringify(allData));
      if (allData?.results?.length) {
        setAllStoreList(allData?.results);
        setToken(
          rawData?.results?.[0]?.token || localConfiguratorData?.tokenUrl
        );
        setCurrentSelectedStore(allData?.results[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="h-100 w-100">
      <div
        className={`${styles.topDiv} ${false ? styles.calcHeight : "h-100"}`}
      >
        <div className="w-100 h-100">
          {!loader && (
            <ImageViewer
              scenes={allScenes}
              isImageViewer={false}
              selectedStoreLocal={currentSelectedStore}
              allStoreList={allStoreList}
              modelId={token}
              isRender={isRender}
              localLayoutData={localLayoutData}
              localImageData={localImageData}
              localProfileData={localProfileData}
              localSceneData={localSceneData}
              measureToolImages={measureToolImages}
              showArButton={showArButton}
              showMeasureTool={showMeasureTool}
              uuid={uuid}
            />
          )}
        </div>
      </div>
      {loader && (
        <AnimatedLoader
          hideLoadingText={true}
          zIndex={1000}
          position="fixed"
          top={0}
          backDrop={"rgba(255, 255, 255, 1"}
        />
      )}
    </div>
  );
};

export default ConfiguratorViewer;
